export default "__VITE_ASSET__303981ec__"